import * as utils from "./utils";

export {read, view, columns, title} from './membership';

export const list = utils.listFn('getMembersByGroupId');



// WEBPACK FOOTER //
// ./src/schemas/membership-in-group.js